import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "region-list-entry d-flex"
}
const _hoisted_2 = { class: "flex-shrink-0 me-4 d-none d-md-block" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start mb-0" }
const _hoisted_6 = { class: "bf-heading-display text-body mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "bf-heading-script text-primary text-nowrap ms-2"
}
const _hoisted_8 = {
  key: 0,
  class: "region-list-entry__parks mb-3 d-none"
}
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-24 col-lg-4" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "flex-shrink-0 me-3 d-md-none" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-60" }, "Gebietsleitung", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "h4 mb-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "my-4 d-inline-block"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "col-24 col-lg-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-60" }, "Qualifikationen", -1)
const _hoisted_22 = { class: "col-24 col-lg-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-60" }, "Angebotene Kurse", -1)
const _hoisted_24 = {
  key: 1,
  class: "my-5 text-center"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionCoursesModal = _resolveComponent("RegionCoursesModal")!

  return (_ctx.regionLocal && !_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.regionLocal.manager.avatar_url || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII=',
            class: "bf-profile-picture bf-profile-picture--shaped mb-3",
            width: "300",
            height: "300",
            alt: 'Gebietsleitung ' + _ctx.regionLocal.name
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.regionLocal.name) + " ", 1),
              (_ctx.region?.distance)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(Math.round(_ctx.region.distance / 1000)) + " km", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.parksString)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.parksString), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: _ctx.regionLocal.manager.avatar_url || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII=',
                    class: "bf-profile-picture bf-profile-picture--shaped",
                    width: "120",
                    height: "120",
                    alt: 'Gebietsleitung ' + _ctx.regionLocal.name
                  }, null, 8, _hoisted_13)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.regionLocal.manager.prename) + " " + _toDisplayString(_ctx.regionLocal.manager.surname), 1)
                  ]),
                  (_ctx.regionLocal.manager?.profile?.job)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("i", null, _toDisplayString(_ctx.regionLocal.manager?.profile?.job), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.showCoursesButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("a", {
                      href: _ctx.$navigation.buildRouteUrl('region', {slug: _ctx.region.slug}),
                      class: "btn btn-primary d-block"
                    }, "Kursangebot & Anmeldung", 8, _hoisted_19)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.regionLocal.manager?.profile?.qualification?.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_21,
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionLocal.manager.profile.qualification.slice(0, 4), (entry) => {
                        return (_openBlock(), _createElementBlock("li", { key: entry }, _toDisplayString(entry), 1))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.regionLocal?.courseTypes || []), (courseType) => {
                  return (_openBlock(), _createElementBlock("li", { key: courseType }, _toDisplayString(courseType), 1))
                }), 128))
              ])
            ])
          ])
        ]),
        _createVNode(_component_RegionCoursesModal, {
          regionId: _ctx.regionLocal.id,
          shown: _ctx.modalShown,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalShown = false))
        }, null, 8, ["regionId", "shown"])
      ]))
    : (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
      : _createCommentVNode("", true)
}